module.exports = __webpack_public_path__ + "img/whl (1).575f4ac1.png";